import React from 'react'
import { constructUrl, filterBlockByType, isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import Link from '../link/Link'

const FooterTopDropdownLinksItem = ({ block, blockType }) => {
    const blockTitle = filterBlockByType(block?.childrens, 'Titre')
    const blockSource = block.childrens.filter((child) => child.block === 'Source')
    const blockComplement = block.childrens.filter((child) => child.block === 'Complement')

    const newBlockSource = (content) => {
        return [{ block: 'Source', content: content }]
    }

    return !isEmpty(block.attributes) ? (
        <div className="baseocom-footer-top-dropdown-link-item">
            <div className="baseocom-footer-top-dropdown-link-item-content">
                {/* LINK */}
                {block.attributes.important !== 'non' && blockTitle ? (
                    <>
                        <Link
                            isIcon={false}
                            url={
                                block?.attributes?.external_link
                                    ? block?.attributes?.URL
                                    : constructUrl(
                                          block?.attributes.ID,
                                          block?.attributes?.audience
                                      )
                            }
                            targetBlank={block?.attributes?.URL ? true : false}
                        >
                            <span className="baseocom-footer-top-link-item-icon">
                                {icon('arrow-right')}
                            </span>
                            {blockTitle?.content}
                        </Link>

                        {block?.attributes?.URL ? icon('external-link') : null}
                    </>
                ) : (
                    <div>
                        <Parser content_block={block?.childrens} />
                    </div>
                )}
            </div>
            {blockSource && blockType !== 'ServiceEnLigne' ? (
                <Parser content_block={blockSource} />
            ) : null}
            {isEmpty(blockSource) && blockType !== 'Complement' ? (
                <Parser content_block={blockComplement} />
            ) : null}
            {blockType === 'VoirAussi' && isEmpty(blockSource) ? (
                <Parser content_block={newBlockSource('ServicePublic')} />
            ) : null}
            {block?.attributes?.type && blockType === 'ServiceEnLigne' ? (
                <Parser content_block={newBlockSource(block?.attributes?.type)} />
            ) : null}
        </div>
    ) : (
        <Parser content_block={block?.childrens} />
    )
}

export default FooterTopDropdownLinksItem
